import { useState } from "react";
import { MailWarning, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function VerifyEmailBanner({ email }) {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success(`Verification email sent to ${email}`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="verify-email-banner">
      <MailWarning className="h-6 w-6 text-amber-700 shrink-0" />
      <div className="flex-1">
        <p className="font-semibold text-amber-900">Please verify your email address</p>
        <p className="text-sm text-amber-800">We sent a link to <strong>{email}</strong>. Verification is needed before you can give consent or pay.</p>
      </div>
      <button onClick={resend} disabled={busy} className="ds-btn h-10 inline-flex items-center gap-2 bg-amber-900 text-white hover:bg-amber-800 disabled:opacity-60" data-testid="resend-verification-button">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Resend email
      </button>
    </div>
  );
}
